import React, { useEffect, useState } from 'react';
import {
  Create,
  SimpleForm,
  useDataProvider,
  useNotify,
  Toolbar,
  SaveButton,
} from 'react-admin';
import { Snackbar, Alert } from '@mui/material';
import RecipesFormFields from '../customForms/RecipesFormFields';

const CustomToolbar = () => {
  const notify = useNotify();

  const onSuccess = (data) => {
    if (data?.message) {
      notify(data.message, { type: 'info' });
    } else {
      notify('Recipe created.', { type: 'info' });
    }
  };

  return (
    <Toolbar>
      <SaveButton mutationOptions={{ onSuccess }} />
    </Toolbar>
  );
};

const RecipesCreate = () => {
  const dataProvider = useDataProvider();
  const [fileOptions, setFileOptions] = useState({ Pdfs: [], Images: [], Videos: [] });
  const [companyID, setCompanyID] = useState(undefined);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const result = await dataProvider.listFiles();
        const allFiles = [...(result.Pdfs || []), ...(result.Images || []), ...(result.Videos || [])];

        setFileOptions({
          Pdfs: allFiles.filter(f => f.toLowerCase().endsWith('.pdf')),
          Videos: allFiles.filter(f => f.toLowerCase().endsWith('.mp4')),
          Images: allFiles.filter(f => !f.toLowerCase().endsWith('.pdf') && !f.toLowerCase().endsWith('.mp4')),
        });

        setCompanyID(result.companyID);
      } catch (err) {
        console.error('Failed to fetch files', err);
        setErrorMessage('Failed to load files.');
        setSnackbarOpen(true);
      }
    };

    fetchFiles();
  }, [dataProvider]);

  return (
    <>
      <Create title="Nova Receita" redirect="edit">
        <SimpleForm toolbar={<CustomToolbar />}>
          <RecipesFormFields
            fileOptions={fileOptions}
            companyID={companyID}
          />
        </SimpleForm>
      </Create>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="error" onClose={() => setSnackbarOpen(false)}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default RecipesCreate;
